import { render } from "./TextAreaInput.vue?vue&type=template&id=3f40cdd9"
import script from "./TextAreaInput.vue?vue&type=script&lang=js"
export * from "./TextAreaInput.vue?vue&type=script&lang=js"

import "./TextAreaInput.vue?vue&type=style&index=0&id=3f40cdd9&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__